import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import InternalHeader from "../components/InternalHeader";
import { useAppState } from "../context/AppState";
import { authenticatedApi } from "../lib/api";
import { useLocale } from "../context/Locale";

export default function FavoritesPage() {
  const { address, user } = useAppState();
  const { t } = useLocale();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(Boolean(user));
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.auth_token) return;
    authenticatedApi("/get-favorite-stores", user.auth_token, {
      method: "POST",
      body: JSON.stringify({
        latitude: Number(address?.lat || -9.52779),
        longitude: Number(address?.lng || -77.52778),
      }),
    })
      .then((response) => setStores(Array.isArray(response) ? response : []))
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [address?.lat, address?.lng, user?.auth_token]);

  return (
    <main className="food-app">
      <InternalHeader title={t("favoriteTitle")} backTo="/account" />
      <div className="favorites-page">
        {!user && (
          <section className="empty-cart">
            <span>♡</span>
            <h2>{t("favoriteLogin")}</h2>
            <Link to="/account?next=/favorites">Ir a mi cuenta</Link>
          </section>
        )}
        {loading && <div className="food-message"><b>Cargando favoritos…</b></div>}
        {error && <div className="food-message food-message--error"><b>{error}</b></div>}
        {!loading && user && !error && !stores.length && (
          <section className="empty-cart">
            <span>♡</span>
            <h2>{t("noFavoritesZone")}</h2>
            <p>{t("favoriteEmptyHelp")}</p>
            <Link to="/food">{t("browseStores")}</Link>
          </section>
        )}
        <section className="favorite-list">
          {stores.map((store) => (
            <Link to={`/food/stores/${store.slug}`} key={store.id}>
              <img src={store.image} alt={store.name} loading="lazy" />
              <div>
                <h2>{store.name}</h2>
                <p>{store.description}</p>
                <small>★ {store.avgRating || store.rating || "0"} · ◷ {store.delivery_time || "20"} min</small>
              </div>
              <span>›</span>
            </Link>
          ))}
        </section>
      </div>
      <BottomNav />
    </main>
  );
}
